<template>
    <div>
        <!-- 搜索 -->
        <search   :search="true" :type="'AuthorityManagement'" @add-data="add_data" @search-data="search_data" @Export="Export" @Import="() => { this.ImportChild = true }"></search>
        <!-- 列表 -->
        <tables id="table-box"  :tableData="tableData"  :tableLabel="tableLabel" :ifheader="false" :Calculate="false" @event-button="event_button" ></tables>
        <!-- 新增接口 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_Authority" :title="title"  :width="'720px'" v-if="New_Authority">
            <NewAuthority :visibles.sync="New_Authority" @Render="Render" :type="type" :row="row"></NewAuthority>
        </el-dialog>
         <!-- 分页 -->
        <pagination
            v-show="(Number(total) > 0)"
            :total="Number(total)"
            :page.sync="matterParams.current"
            :limit.sync="matterParams.size"
            @pagination="Render"
        />
        <!-- 导入时选择子系统 -->
        <el-dialog title="选择子系统" :close-on-click-modal="false" :visible.sync="ImportChild" :width="'20%'" v-if="ImportChild">
          <el-form label-width="90px" v-if="ImportChild" ref="formfile">
            <el-form-item label="子系统：" class="el_main" prop="deptId" >
              <el-select v-model="uploadData.modelId" placeholder="请选择子系统" style="width:100%;" filterable clearable>
                <el-option
                  v-for="item in SubsystemList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择文件：" class="el_main" prop="deptId" >
              <el-row>
                <!-- 导入 -->
                <el-upload
                    name="file"
                    ref="uploadfile"
                    :show-file-list="true"
                    :auto-upload="false"
                    action="String"
                    accept=".json"
                    :headers="uploadHeaders"
                    :file-list="fileList"
                    :limit="1"
                    :on-change="uploadchange"
                    :before-remove="beforeremove"
                    class="upload_imgs">
                    <el-button type="primary" plain size="mini">点击上传</el-button>
                </el-upload>
              </el-row>
            </el-form-item>
            <el-row>
              <el-col style="text-align: center;">
                <el-button :disabled="(uploadData.modelId && fileList.length) ? false : true" @click="submitfile">确定</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-dialog>
    </div>
</template>
<script>
import NewAuthority from '../dialog/NewAuthority'
import { uploadUrlsJSON } from '@/api/commonhttp'
// import tools from '@/utils/tools'
export default {
  components: {
    NewAuthority
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
      fileList: [],
      New_Associated_User: false,
      SubsystemList: [],
      ImportChild: false,
      New_Authority: false,
      title: '',
      total: 0,
      type: '',
      row: {},
      uploadHeaders: {
        Authorization: ''
      },
      uploadData: {
        modelId: null
      },
      matterParams: {
        // 默认显示页数
        current: 1,
        // 一页几条数据
        size: 10
      },
      tableData: [],
      listData: [],
      tableLabel: [
        { label: '序号', width: '80', prop: 'index', align: 'center' },
        { label: '访问路径', width: '', prop: 'url', align: 'center' },
        { label: '接口描述', width: '', prop: 'description', align: 'center' },
        { label: '子系统', width: '', prop: 'modelName', align: 'center' },
        { label: '请求方式', width: '100', prop: 'reqMethod', align: 'center' },
        {
          label: '操作',
          width: '160',
          align: 'center',
          isOpera: true, // 判断是否生成按钮
          titleList: [
            // { title: '增加子级接口', status: 'primary' },
            { title: '修改', status: 'primary' },
            { title: '删除', status: 'primary' }
          ]
        }
      ]
    }
  },
  methods: {
    // submitfile
    submitfile () {
      const formData = new FormData()
      formData.append('file', this.fileList[0].raw)
      formData.append('modelId', this.uploadData.modelId)
      uploadUrlsJSON(formData).then((res) => {
        this.ImportChild = false
        if (res.status === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          })
          this.Render()
        } else {
          this.$message({
            message: '导入失败,请重新导入',
            type: 'error'
          })
        }
      })
    },
    // 文件移除触发
    beforeremove (file, fileList) {
      this.fileList = []
    },
    // 文件发生改变触发
    uploadchange (file, fileList) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      const whiteList = ['json']
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message({ message: '上传文件只能是 josn 格式', type: 'warning' })
        this.fileList = []
        return false
      } else {
        this.fileList = [file]
      }
    },
    // 新增
    add_data (v) {
      this.title = '新增接口'
      this.New_Authority = true
      this.type = 'add'
      this.row = {}
    },
    // 所属部门
    departmentRemoteMethod (query) {
      this.loading = true
      setTimeout(() => {
        this.departmentList = this.$Layoutfun.ProcessingData(query, this.$department.list(), 'name')
        this.loading = false
      }, 300)
    },
    // 下拉框事件改变
    ChangeSelectFun (event) {
      if (!event) {
        this.departmentRemoteMethod(event)
      }
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1
      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 导出
    Export () {
      // this.tableLabel[8].ifshow = true
      setTimeout(() => {
        this.$tableToExcel('#table-box .el-table', '接口信息.xlsx')
        // this.tableLabel[8].ifshow = false
      })
      this.$message.success('导出成功')
    },
    // 导入
    Imports () {
      this.$refs.uploadfile.$refs['upload-inner'].handleClick()
    },
    // 列表按钮
    event_button (type, row) {
      if (type === '修改') {
        this.New_Authority = true
        this.title = '修改接口'
        this.type = 'edit'
        this.row = row
      } else if (type === '删除') {
        this.$confirm('此操作将永久删除该接口, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.Delete('/path/api-url/deleteById', { id: row.id }).then((res) => {
            this.$message.success('删除成功')
            this.Render()
          })
        }).catch(() => {})
      } else if (type === '增加子级权限') {
        this.New_Authority = true
        this.title = '增加子级权限'
        this.type = 'AddAuthority'
        this.row = row
      }
    },
    // 列表数据
    Render () {
      this.$http.get('/path/api-url/page', this.matterParams).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
      // this.$http.get('/path/api-url/page').then((res) => {
      //   sessionStorage.removeItem('AutocompleteList')
      //   this.listData = [
      //     { type: 'url', value: [] },
      //     { type: 'description', value: [] }
      //   ]
      //   res.data.records.forEach((item) => {
      //     this.listData[0].value.push({
      //       value: item.url
      //     })
      //     this.listData[1].value.push({
      //       value: item.description
      //     })
      //   })
      //   sessionStorage.setItem('AutocompleteList', JSON.stringify(this.listData))
      // })
    }
  },
  created () {
    this.SubsystemList = this.$Subsystem.list()
    this.Render()
  },
  watch: {
    ImportChild (v) {
      if (!v) {
        this.fileList = []
        this.uploadData = {
          modelId: null
        }
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
    // .main{
    //     display: flex;
    //     height: 800px;
    //     padding: 20px 0px 0 50px;
    //     .right{
    //        background: green;
    //        width: 100%;
    //        height: 100%;
    //     }
    // }
</style>
